import { Button } from "@progress/kendo-react-buttons";
import React, { CSSProperties, FC } from "react";
import style from "../styles.module.css";
import { COLOR } from "../utils/constant";

export interface CustomButtonProps {
	iconName?: string;
	label: string;
	onClick: () => void;
	disabled?: boolean;
	bgColor?: string;
	color?: string;
	iconRight?: boolean;
	className?: string;
	gap?: string;
	btnStyle?: CSSProperties;
	labelStyle?: CSSProperties;
	id?: any;
	title?: string;
}

export const TextButton: FC<{
	iconName?: string;
	iconWidth?: number;
	iconHeight?: number;
	text: string;
	textStyle?: React.CSSProperties;
	iconStyle?: React.CSSProperties;
	bgStyle?: React.CSSProperties;
	disabled?: boolean;
	onClick: () => void;
}> = ({
	iconName,
	onClick,
	text,
	iconHeight = 15,
	iconWidth = 15,
	textStyle,
	iconStyle,
	disabled = false,
	bgStyle = { backgroundColor: COLOR.Grey98 },
}) => {
	const handleClick = () => {
		if (disabled) return;
		if (onClick) {
			onClick();
		}
	};

	return (
		<div
			className={style.TextButton}
			onClick={handleClick}
			style={{
				cursor: disabled ? "not-allowed" : "pointer",
				borderRadius: "4px",
				paddingLeft: "6px",
				paddingRight: "6px",
				height: "39px",
				backgroundColor: COLOR.Grey98,
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				border: "none",
				opacity: disabled ? 0.5 : 1,
				pointerEvents: disabled ? "none" : "auto",
				...bgStyle,
			}}
		>
			{text && (
				<div
					style={{
						textAlign: "center",
						...textStyle,
					}}
				>
					{text}
				</div>
			)}
			{iconName && (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<img
						src={`/icon/${iconName}.svg`}
						alt={text}
						style={{
							width: `${iconWidth}px`,
							height: `${iconHeight}px`,
							...iconStyle,
						}}
					/>
				</div>
			)}
		</div>
	);
};

export const CustomButton: FC<CustomButtonProps> = ({
	iconName,
	onClick,
	label,
	title,
	disabled = false,
	bgColor = COLOR.Grey98,
	color,
	iconRight = true,
	className,
	gap = "8px",
	labelStyle,
	btnStyle,
}) => {
	const handleClick = () => {
		if (onClick) {
			onClick();
		}
	};
	return (
		<Button
			title={title}
			style={{
				color: color,
				backgroundColor: bgColor,
				borderRadius: "4px",
				borderColor: "transparent",
				//height: "32px ",
				height: "39px",
				cursor: disabled ? "not-allowed" : "pointer",

				...btnStyle,
			}}
			className={`${style.ButtonItem} ${className} `}
			//className={`${style.ButtonItem} ${className} btn-style`}
			onClick={handleClick}
			disabled={disabled}
		>
			<div
				style={{ display: "flex", gap, ...labelStyle }}
				className={style.ButtonLabel}
			>
				{iconRight ? (
					<>
						{label}

						{iconName && (
							<img src={`/icon/${iconName}.svg`} alt={iconName} style={{}} />
						)}
					</>
				) : (
					<>
						{iconName && <img src={`/icon/${iconName}.svg`} alt={iconName} />}
						{label}
					</>
				)}
			</div>
		</Button>
	);
};

export default CustomButton;
